import React from 'react'
import classes from './AvailabilitySecond.module.css';
import moment from 'moment'
import { Col, Row, Form,Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actionTypes from '../../../Action/Index';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'
import LOGO from '../../commonComponents/NetworkError/img/No data (2).png'
class AvailabilitySecond extends React.Component
{

    state={
        valueSelected : "",
        timeArray:[1,2,3,4,5,6,7,8],
        currentDate:new Date(),

    }
    componentDidMount=()=>{
        let date=moment(this.state.currentDate).unix()
        this.props.getInterviewerTimeSlots(date*1000,this.props.id)
    }
    leftClick=()=>{

        let newDate=new Date(this.state.currentDate)
       let currentDate=moment(this.state.currentDate).format("DD/MM/YYYY")
       let toDay=moment(new Date()).format("DD/MM/YYYY")

        if(toDay==currentDate)
        {
            return false;
        }
        let tomorrow=newDate.setDate(newDate.getDate()-1)

        this.setState({
            currentDate:tomorrow
        },()=>{
            let date=moment(this.state.currentDate).unix()
            this.props.getInterviewerTimeSlots(date*1000,this.props.id)
        })
    }
    rightClick=()=>{
        let date = new Date()
        date.setDate(date.getDate() + 15)
        let currentDate=moment(this.state.currentDate).format("DD/MM/YYYY")
       let Dayafter15=moment(date).format("DD/MM/YYYY")

        if(currentDate==Dayafter15)
        {
            return false;
        }
       
        let newDate=new Date(this.state.currentDate)
        let tomorrow=newDate.setDate(newDate.getDate()+1)

        this.setState({
            currentDate:tomorrow
        },()=>{
            let date=moment(this.state.currentDate).unix()
            this.props.getInterviewerTimeSlots(date*1000,this.props.id)
        })
       
    }
    render(){
       
        let date=moment(this.state.currentDate).format("DD MMM")

        let newDate=new Date(this.state.currentDate)
        let tomorrow=newDate.setDate(newDate.getDate()+1)
       
        //let newDate=new Date(this.state.currentDate)
        let currentDate=moment(this.state.currentDate).format("DD/MM/YYYY")
        let toDay=moment(new Date()).format("DD/MM/YYYY")
        var leftCompare=toDay==currentDate

        let date15 = new Date()
        date15.setDate(date15.getDate() + 15)
        let rcurrentDate=moment(this.state.currentDate).format("DD/MM/YYYY")
       let Dayafter15=moment(date15).format("DD/MM/YYYY")
        var rightCompare=rcurrentDate==Dayafter15

        let time = new Date()
       
        var timelist=""
        if(this.props.myScheduleTimingResponseList!=null && this.props.myScheduleTimingResponseList.length!=0){
            var timelist=this.props.myScheduleTimingResponseList.map((ind, inde)=>{
                var timeobject = new Date(ind.startTime*1);
               var hourstart = moment(timeobject).format('hh:mm A')

               let val=time.getHours()*60+time.getMinutes() >= timeobject.getHours()*60+timeobject.getMinutes();

               if(!((time.getDate() === parseInt(date.split(" ")[0])) && val)){
                return(
                    <Col md={3} style={{padding: "3px"}}>
                     <label className={classes.labelInput}>
                         {/* {
                             (time.getDate() === parseInt(date.split(" ")[0])) && val ?
                             <div>
                             <input type="radio" name="start" disabled={true}
                          value={moment(this.state.currentDate).format("DD MMM")+ ' - ' +hourstart}/>
                         <span className={classes.hourstart} style={{backgroundColor: "#b3b3b3",color:"white"}} >
                          {hourstart}
                          </span>
                             </div>
                             : */}

                             <div>
                             <input type="radio" name="start" disabled={ind.interviewSchedule?true:false}
                          value={moment(this.state.currentDate).format("DD MMM")+ ' - ' +hourstart}
                           onClick={(e)=>{this.props.onRadioSelect(e,this.props.obj, inde); }}/>
                         <span className={classes.hourstart} style={ind.interviewSchedule ? {textDecoration:"none",backgroundColor:"#ff3333",color:"white"}: (this.props.interviewerProfileValue.id==this.props.id && this.props.text.split("-")[0].trim()==date && this.props.index === inde )? {backgroundColor: "#00a99d", color: 'white'}:{textDecoration:"underline",cursor:"pointer"}} >
                          {hourstart}
                          </span>
                             </div>
                         
                     </label>
                    </Col>
                )
               }
                //  return(
                //     <Col md={3} style={{padding: "3px"}}>
                //      <label className={classes.labelInput}>
                //          {
                //              (time.getDate() === parseInt(date.split(" ")[0])) && val ?
                //              <div>
                //              <input type="radio" name="start" disabled={true}
                //           value={moment(this.state.currentDate).format("DD MMM")+ ' - ' +hourstart}/>
                //          <span className={classes.hourstart} style={{backgroundColor: "#b3b3b3",color:"white"}} >
                //           {hourstart}
                //           </span>
                //              </div>
                //              :

                //              <div>
                //              <input type="radio" name="start" disabled={ind.interviewSchedule?true:false}
                //           value={moment(this.state.currentDate).format("DD MMM")+ ' - ' +hourstart}
                //            onClick={(e)=>{this.props.onRadioSelect(e,this.props.obj, inde); }}/>
                //          <span className={classes.hourstart} style={ind.interviewSchedule ? {textDecoration:"none",backgroundColor:"#ff3333",color:"white"}: (this.props.interviewerProfileValue.id==this.props.id && this.props.text.split("-")[0].trim()==date && this.props.index === inde )? {backgroundColor: "#00a99d", color: 'white'}:{textDecoration:"underline",cursor:"pointer"}} >
                //           {hourstart}
                //           </span>
                //              </div>
                //          }
                //      </label>
                //     </Col>
                // )
            } )
        }else{
            timelist=<>
            <Col className="d-flex justify-content-center">
              <img height="100px" width="100px" style={{alignItems:"center"}} src={LOGO} alt="No Data"></img>
            </Col>
            <Col
            lg={12}>
               <div className={classes.noslotAvailable}>No slots available</div>
           </Col>
           </>
        }
        return (
            <Modal
              {...this.props}
              
              aria-labelledby="contained-modal-title-vcenter"
              centered

             
            >
              <Modal.Body>
              <h4 style={{textAlign:"center",marginTop:"6px",color:"#00a99d",fontWeight:"bold"}}>
                            Select Your Time Slot
              </h4><br/>
              <Row>
                       
                             <Col lg={12} className={classes.makedatecenter}> 
                             <i className="fas fa-angle-left" onClick={()=>this.leftClick()} 
                       style={!leftCompare?{color: '#fbb03b',fontSize: '25px',cursor:"pointer",marginRight:"15px"}:{color: 'grey',fontSize: '25px',marginRight:"15px"}}></i>
                               
                             <span className={classes.AvailabilityDateSlot}>{date}</span>

                             <i className="fas fa-angle-right" onClick={()=>this.rightClick()} 
                             style={!rightCompare?{color: '#fbb03b',fontSize: '25px',cursor:"pointer",marginLeft:"15px"}:
                             {color: 'grey',fontSize: '25px',marginLeft:"15px"}}
                             ></i>

                             </Col>
                      
                      
             </Row><br/>
             <Loader show={this.props.loader} message={ <Spinner animation="border" role="status"></Spinner> } style={{height:"auto"}}
            foregroundStyle={{color: '#fbb03b'}}
            backgroundStyle={{backgroundColor: 'white'}}
             >
                          <div style={{height:"170px",overflow:"auto",paddingTop: "5px"}}>
                           <Row style={{width: "98%", marginLeft: "1%"}}>
                               {console.log('hello', timelist)}
                           {
                                 Array.isArray(timelist) && timelist.filter(item => item !== undefined).length === 0 ?
                                 <>
                                 <Col className="d-flex justify-content-center">
                                    <img height="100px" width="100px" style={{alignItems:"center"}} src={LOGO} alt="No Data"></img>
                                    </Col>
                                 <Col
                                    lg={12}>
                                    <div className={classes.noslotAvailable}>No slots available</div>
                                </Col>
                                </>:
                                timelist
                                }
                           </Row>
                           </div>
                           <br/>
                           
        </Loader>
        <div><span><i class="fa fa-circle" style={{color:"#ff3333",marginLeft:"10px",fontSize: "12px"}}></i></span>&nbsp; <span style={{fontSize: "15px"}}>Already booked Time Slot</span></div>
        {/* <div><span><i class="fa fa-circle" style={{color:"#b3b3b3",marginLeft:"10px",fontSize: "12px"}}></i></span>&nbsp; <span style={{fontSize: "15px"}}>Past Time Slot</span></div> */}
                                   
        <Row>
 
                      <Col lg={12}>
                            <div style={{display:"flex",justifyContent:"center"}}>
                            <button onClick={()=>{this.props.availabilityModalHandler()}}
                              className={classes.okButton}>OK</button>
                              </div>
                             </Col>
                              
                           </Row>
              </Modal.Body>

            </Modal>
          );
        }
    }



const mapStateToProps = (state) => {
    return {
        loader:state.employeeReducer.getInterviewerTimeSlotsLoader,
        myScheduleTimingResponseList: state.employeeReducer.myScheduleTimingResponseList,
        interviewerAvailableSlotResponseList: state.employeeReducer.interviewerAvailableSlotResponseList,
        getInterviewerTimeSlotsFailMsg: state.employeeReducer.getInterviewerTimeSlotsFailMsg,
        getInterviewerTimeSlotsNetworkError: state.employeeReducer.getInterviewerTimeSlotsNetworkError,
       
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getInterviewerTimeSlots: (date,id) => dispatch(actionTypes.getInterviewerTimeSlots(date,id)),
       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilitySecond);
